<template>
  <div class="member-wrapper">
    <div class="banner-wrapper">
      <img
        src="https://pic.lehe.com/pic/_o/24/72/f5b40ebd6d01c793e6ac6d394fcf_3840_1600.cz.png"
        class="banner-img">
      <img
        src="https://pic.lehe.com/pic/_o/cb/b3/6f336e15a7be19287f81b31925f3_2124_978.cz.png"
        class="banner-text" />
    </div>
    <div class="content1">
      <img
        src="https://pic.lehe.com/pic/_o/a0/a9/d76f16f5bd417713e806b63456d4_2400_2400.cz.png"
        class="content1-img">
      <div class="content1-content">
        <p class="title">
          【 会员专属 】
        </p>
        <p class="content">
          我们是由一群热爱美感和设计的、
          <br>
          喜欢创造新东西的，
          <br>
          热诚、挑剔、有趣的人们创立的。
        </p>
        <p class="tip">
          我们是会员专属的。
        </p>
        <input
          type="button"
          class="apply-btn"
          value="申请会员"
          @click="handleApplyShow">
      </div>
    </div>
    <div class="content2">
      <div class="content-normal-text">
        <p class="title">
          连接
        </p>
        <p class="tip">
          在小着，会员可以拍摄超高品质的视频，展现真实、美好、有趣的
          <br>
          自己，彼此连接。
        </p>
      </div>
      <div class="content2-content">
        <div class="content-item">
          <video
            ref="video1"
            loop
            src="https://image.lehe.com//xzworks/video/074b5ebd306fad06ae64d91bedbc3e61"
            class="item-video" />
          <div
            class="video-mask"
            @click="handleMaskClick('video1', 'video2')">
            <img
              v-show="!video1Play"
              src="../../assets/play.png"
              class="video-btn">
          </div>
        </div>
        <div
          class="content-item">
          <video
            ref="video2"
            loop
            src="https://image.lehe.com//xzworks/video/9c81975d31db41906e3c271b9ba95f8e"
            class="item-video" />
          <div
            class="video-mask"
            @click="handleMaskClick('video2', 'video1')">
            <img
              v-show="!video2Play"
              src="../../assets/play.png"
              class="video-btn">
          </div>
        </div>
      </div>
    </div>
    <div class="content3">
      <div class="content-normal-text">
        <p class="title">
          灵感
        </p>
        <p class="tip">
          在小着，会员可以翻阅设计、艺术、创意等精品图书，
          <br>
          轻松地逗留在这里，惬意地享受闲暇时光，
          <br>
          获得灵感，随时分享。
        </p>
      </div>
      <img
        src="https://pic.lehe.com/pic/_o/93/da/c96f2f7f0e115be0a8f9c521a54f_2400_1350.cz.png"
        class="normal-img">
      <img
        src="https://pic.lehe.com/pic/_o/98/66/371a9bae61d1e0d1091015a96f97_2400_1350.cz.png"
        class="normal-img content3-img2">
    </div>
    <div class="content4">
      <div class="content-normal-text">
        <p class="title">
          能量
        </p>
        <p class="tip">
          在小着，会员可以享受超高品质、透明成本、
          <br>
          零利润的赛级咖啡和鲜榨果汁，更有能量。
        </p>
      </div>
      <img
        src="https://pic.lehe.com/pic/_o/e5/78/a6540301ec081a3a4dbd440952bf_2400_1350.cz.png"
        class="normal-img">
      <div class="content4-img2">
        <img src="https://pic.lehe.com/pic/_o/5a/4f/4894d722a2b9fe6838b9ae3ec8a4_1120_1492.cz.png">
        <img src="https://pic.lehe.com/pic/_o/e2/7b/d692943785763bab54cd4c46004b_1120_1492.cz.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      video1Play: false,
      video2Play: false
    }
  },
  methods: {
    handleApplyShow () {
      this.$store.commit('SET_APPLY_SHOW', true)
    },
    handleMaskClick (target, other) {
      const currVideo = this.$refs[target]
      const otherVideo = this.$refs[other]
      if (currVideo.paused) {
        otherVideo.pause()
        currVideo.play()
        this[target + 'Play'] = true
        this[other + 'Play'] = false
      } else {
        currVideo.pause()
        this[target + 'Play'] = false
      }
    }
  }
}
</script>

<style lang="scss">
  .member-wrapper {
    padding-bottom: 150px;
    .banner-wrapper {
      position: relative;
      .banner-img {
        width: 100%;
        min-height: 500px;
      }
      .banner-text {
        position: absolute;
        top: 32.5%;
        left: 18.75%;
        width: 36.875%;
      }
    }
    .content1 {
      width: 1200px;
      margin: 150px auto 0;
      position: relative;
      .content1-img {
        width: 100%;
        height: 1200px;
      }
      .content1-content {
        position: absolute;
        top: 0;
        bottom: 0;
        padding-top: 300px;
        width: 100%;
        color: #fff;
        text-align: center;
        background: rgba(0,0,0,.3);
        filter: progid:DXImageTransform.Microsoft.gradient(startcolorstr=#4c000000, endcolorstr=#4c000000);
        .title {
          line-height: 44px;
          font-size: 30px;
          font-weight: 600;
        }
        .content {
          margin-top: 40px;
          line-height: 60px;
          font-size: 40px;
          font-weight: 600;
        }
        .tip {
          margin-top: 60px;
          line-height: 44px;
          font-size: 30px;
          font-weight: 300;
        }
        .apply-btn {
          width: 180px;
          line-height: 54px;
          margin-top: 100px;
          background-color: #fff;
          font-size: 20px;
          font-weight: 400;
          border-radius: 4px;
          cursor: pointer;
        }
      }
    }
    .content-normal-text {
      text-align: center;
      .title {
        line-height: 40px;
        font-size: 40px;
        font-weight: 500;
        color: #000;
      }
      .tip {
        margin-top: 40px;
        line-height: 36px;
        font-size: 20px;
        color: #000;
        font-weight: 300;
        font-family:PingFangSC-Light,PingFang SC;
      }
    }
    .normal-img {
      width: 1200px;
      margin-top: 80px;
    }
    .content2 {
      margin-top: 150px;
      text-align: center;
      .content2-content {
        display: inline-block;
        margin-top: 80px;
        .content-item {
          position: relative;
          display: inline-block;
          margin-left: 120px;
          &:first-of-type {
            margin-left: 0;
          }
          .item-video {
            width: 100%;
          }
          .video-mask {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            cursor: pointer;
            &:after {
              content: '';
              display: inline-block;
              height: 100%;
              vertical-align: middle;
            }
            .video-btn {
              width: 80px;
              height: 80px;
              vertical-align: middle;
              cursor: pointer;
            }
          }
        }
      }
    }
    .content3 {
      width: 1200px;
      margin: 200px auto 0;
      .content3-img2 {
        margin-top: 100px;
      }
    }
    .content4 {
      width: 1200px;
      margin: 150px auto 0;
      .content4-img2 {
        margin-top: 80px;
        img {
          width: 560px;
          margin-left: 80px;
          &:first-of-type {
            margin-left: 0;
          }
        }
      }
    }
  }
</style>
